/** "Today" / "Tomorrow" / short weekday, keyed by the actual ISO date. */
export function dayLabel(iso: string, todayISO: string): string {
  const offset = Math.round(
    (Date.parse(`${iso}T12:00:00Z`) - Date.parse(`${todayISO}T12:00:00Z`)) / 86_400_000,
  );
  if (offset === 0) return "Today";
  if (offset === 1) return "Tomorrow";
  const d = new Date(iso + "T00:00:00Z");
  return d.toLocaleDateString("en-GB", { weekday: "short" });
}

/** Short "5 Jan" style date for a forecast day. */
export function dateLabel(iso: string): string {
  const d = new Date(iso + "T00:00:00Z");
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}
